import React from "react";
import Scaffold from "../../widget/layouts/Scaffold";
import AppTranslation from "../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import EmailContent from "./EmailContent";

const EmailScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <Scaffold appBarTitle={AppTranslation.text("email")}>
      <MainBodyContainer>
        <EmailContent type={type} isModal={false} />
      </MainBodyContainer>
    </Scaffold>
  );
};

export default EmailScreen;
export const routeName : string= "/emails";
